import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CountryCodeSelectorComponent } from './country-code-selector.component';
import { MatSelectCountryModule } from '@angular-material-extensions/select-country';

@NgModule({
  declarations: [CountryCodeSelectorComponent],
  imports: [MatSelectCountryModule.forRoot('en')],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CountryCodeSelectorComponent],
})
export class CountryCodeSelectorModule {}
